module.exports = __webpack_public_path__ + "media/recipes/59-bfbad58f.png";